import getConfig from 'next/config'

const { CDN_URL } = getConfig().publicRuntimeConfig

export default {
  FESTIVALS: [
    `${CDN_URL}/static/images/festivals-cover-1.jpg`,
    `${CDN_URL}/static/images/festivals-cover-2.jpg`,
    `${CDN_URL}/static/images/festivals-cover-3.jpg`,
    `${CDN_URL}/static/images/festivals-cover-4.jpg`,
  ],
  CONCERTS: [
    `${CDN_URL}/static/images/concerts-cover-1.jpg`,
    `${CDN_URL}/static/images/concerts-cover-2.jpg`,
    `${CDN_URL}/static/images/concerts-cover-3.jpg`,
    `${CDN_URL}/static/images/concerts-cover-4.jpg`,
    `${CDN_URL}/static/images/concerts-cover-5.jpg`,
    `${CDN_URL}/static/images/concerts-cover-6.jpg`,
    `${CDN_URL}/static/images/concerts-cover-7.jpg`,
  ],
  CLUBS: [
    `${CDN_URL}/static/images/club-nights-cover-1.jpg`,
    `${CDN_URL}/static/images/club-nights-cover-2.jpg`,
  ],
  SPORTS: [`${CDN_URL}/static/images/sports-cover-1.jpg`],
  VOUCHERS_AND_DAY_OUT: [`${CDN_URL}/static/images/vouchers-days-out-cover-1.jpg`],
  default: [
    `${CDN_URL}/static/images/event-cover-1.jpg`,
    `${CDN_URL}/static/images/event-cover-2.jpg`,
    `${CDN_URL}/static/images/event-cover-3.jpg`,
    `${CDN_URL}/static/images/event-cover-4.jpg`,
  ],
}
